// Imports => Constants
import {KEYS} from '../constants/keys.constants';

// Imports => Utilities
import {AcIsSet, AcIsEmptyString} from './ac-get-type-of';
import {AcGetState, AcSaveState} from './ac-storage';

export const AcGetAccessToken = (impersonating = false) => {
  if (impersonating) return AcGetState(KEYS.IMPERSONATED_ACCESS_TOKEN);
  return AcGetState(KEYS.ACCESS_TOKEN);
};

export const AcSetAccessToken = (data, impersonating = false) => {
  if (impersonating) return AcSaveState(KEYS.IMPERSONATED_ACCESS_TOKEN, data);
  return AcSaveState(KEYS.ACCESS_TOKEN, data);
};

export const AcGetTokenType = () => {
  return AcGetState(KEYS.TOKEN_TYPE) || 'Bearer';
};

export const AcGetXUSRToken = () => {
  return AcGetState(KEYS.XUSR_TOKEN);
};

export const AcSetXUSRToken = data => {
  return AcSaveState(KEYS.XUSR_TOKEN, data);
};

export const AcRequestTransformer = (data, headers, json = true) => {
  const access_token = AcGetAccessToken();
  const token_type = AcGetTokenType() || 'Bearer';

  if (AcIsSet(token_type) && AcIsSet(access_token) && !AcIsEmptyString(access_token)) {
    headers['authorization'] = `${token_type} ${access_token}`;
  }

  return json ? JSON.stringify(data) : data;
};
